<template>
<the-header></the-header>
<div class="mt-4">
   <h1 class="text-indigo-600 text-3xl mb-2">Add Candidate</h1>
   <p>Fill the form below to add a new Candidate to the SiBAN voting pool</p>
</div>
<div class="mt-8 flex items-center justify-center">
<form class="flex flex-col md:w-4/5 " @submit.prevent="addEntrepreneur">
        <div class="grid grid-cols-2">
          <div class="my-4 mr-4">
            <input
              v-model="name"
              type="text"
              class="w-full p-2 rounded outline-none border border-indigo-600"
              placeholder="Name"
            />
          </div>
          <div class="my-4 mr-4">
            <input
              v-model="office"
              type="text"
              class="w-full p-2 rounded outline-none border border-indigo-600"
              placeholder="Office"
            />
          </div>
        </div>

        <div class="my-4 mr-4">
          <textarea
            id="bio"
            v-model="bio"
            class="w-full p-2 rounded outline-none border border-indigo-600"
            name="bio"
            placeholder="Bio"
          ></textarea>
        </div>

        <div class="grid md:grid-cols-2 grid-cols-1">
          <div class="my-4 mr-4">
            <select v-model="gender" class="bg-white text-brand-900 px-10 py-4 border border-indigo-600 w-full :focus outline-none">
              <option :value="null" disabled>Select gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>

          <div class="my-4 mr-4">
            <button
              :disabled="disableUploadButton"
              type="button"
              class="rounded p-4 bg-indigo-600 w-full text-white"
              @click="openCloudinaryWidget"
            >
              {{ uploadButtonTitle }}
            </button>
          </div>
        </div>
        <div class="my-4">
          <button type="submit" class="rounded p-4 bg-indigo-600 w-full text-white">
            Add entrepreneur
          </button>
        </div>
      </form>


</div>
 
</template>

<script>
import TheHeader from '../components/Nav/TheHeader.vue'
import { Signer } from '@waves/signer'
import { ProviderWeb } from '@waves.exchange/provider-web'
export default {
  components:{
    TheHeader

  },
  data() {
    return {
      isTestnet: true,
      uploadButtonTitle: 'Upload avatar',
      disableUploadButton: false,
      name: null,
      office: null,
      bio: null,
      avatar: null,
      gender: null,
    }
  },
  computed: {
    dAppAddress() {
      return this.isTestnet
        ? '3MsCcWZK2H5fR6xc6hJy6Mw1iaH47NWjZpg'
        : '3PPiE3H2Xrd1e5cqEs39ezVDMtRWcgJ1HgN'
    },
  },
  methods: {
    generateRandomString(length = 6) {
      return Math.random().toString(20).substr(2, length)
    },
    createCloudinaryWidget() {
      // eslint-disable-next-line no-undef
      const newWidget = new cloudinary.createUploadWidget(
        {
          cloudName: 'developeraspire',
          multiple: false,
          uploadPreset: 'sibanvoting',
          maxFiles: 1,
          cropping: true,
          croppingAspectRatio: 1,
          croppingCoordinateMode: 'face',
          clientAllowedFormats: ['png', 'jpeg'],
          showCompletedButton: true,
          theme: 'blue',
          buttonCaption: 'Upload Entrepreneur Avatar',
          sources: [
            'local',
            'google_drive',
            'url',
            'camera',
            'facebook',
            'instagram',
            'dropbox',
          ],
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            this.uploadButtonTitle = 'Uploaded Successfully'
            this.disableUploadButton = true
            this.avatar = result.info.secure_url
          } else {
            this.uploadButtonTitle = 'Upload avatar'
          }
        }
      )
      return newWidget
    },
    validate() {
      if (
        !this.name ||
        !this.gender ||
        !this.office ||
        !this.bio ||
        !this.avatar
      ) {
        return false
      }
      return true
    },
    openCloudinaryWidget() {
      this.uploadButtonTitle = 'Please wait...'
      if (!this.name || !this.gender || !this.office || !this.bio)
        return alert('All above fields must be filled before uploading avatar')
      const widget = this.createCloudinaryWidget()
      widget.open()
    },
    async addEntrepreneur() {
      // eslint-disable-next-line no-console
      console.log(this.$data)
      if (!this.validate()) return alert('All fields are required')
      const isTestnet = this.isTestnet
      const signer = new Signer({
        // Specify URL of the node on Testnet
        NODE_URL: isTestnet
          ? 'https://nodes-testnet.wavesnodes.com'
          : 'https://nodes.wavesnodes.com',
      })
      signer.setProvider(new ProviderWeb())
      const data = {
        dApp: this.dAppAddress,
        call: {
          function: 'addCandidateProfile',
          args: [
            { type: 'string', value: this.name },
            { type: 'string', value: this.avatar },
            { type: 'string', value: this.bio },
            { type: 'string', value: this.gender },
            { type: 'string', value: this.office },
          ],
        },
      }
      try {
        const tx = await signer.invoke(data).broadcast()
        alert('Entrepreneur added successfully with tx id of ' + tx.id)
        this.$router.push('/home')
        // eslint-disable-next-line no-console
        console.log(tx)
      } catch (error) {
        alert(error.message)
      }
    },
  },
  
}
</script>
